import client from './client';

export const getTransfersPaginated = (params) =>
  client.get('/stock-transfers', { params }).then((r) => r.data);

export const getTransfer = (uuid) =>
  client.get(`/stock-transfers/${uuid}`).then((r) => r.data);

export const createTransfer = (data) =>
  client.post('/stock-transfers', data).then((r) => r.data);

export const shipTransfer = (uuid) =>
  client.post(`/stock-transfers/${uuid}/ship`).then((r) => r.data);

export const receiveTransfer = (uuid, data) =>
  client.post(`/stock-transfers/${uuid}/receive`, data).then((r) => r.data);
